// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + "sentry" + "." + "2190cbb052a8009f46bd" + ".js";
};